<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="row align-items-center">
            <div class="col-lg-8 col-xl-8 col-md-12 col-sm-12 p-2">
              <h4 class="card-header-title">
                Cockpit
              </h4>
            </div>
            <div class="col-lg-4 col-xl-4 col-md-12 col-sm-12 p-2">
              <div class="inner-addon right-addon">
                <input type="text"
                       ngxDaterangepickerMd
                       startKey="start"
                       endKey="end"
                       [alwaysShowCalendars]="alwaysShowCalendars"
                       [keepCalendarOpeningWithRange]="keepCalendarOpeningWithRange"
                       [opens]="opens"
                       [ranges]="ranges"
                       [locale]="locale"
                       [(ngModel)]="selected"
                       [showCustomRangeLabel]="true"
                       [showRangeLabelOnInput]="true"
                       [maxDate]="maxDateSelection"
                       (rangeClicked)="rangeClicked($event)"
                       (datesUpdated)="datesUpdated($event)" class="form-control" placeholder="Wählen Sie Datumsbereich">
                <i class="fe fe-calendar"></i>
              </div>
            </div>
            <!--<div class="col-auto">
              <button (click)="GetAggregatedData('hour')" class="btn mr-2"
                      [class.btn-outline-primary]="range !== 'hour'" [class.btn-primary]="range === 'hour'">
                Tag
              </button>
              <button (click)="GetAggregatedData('month')" class="btn mr-2"
                      [class.btn-outline-primary]="range !== 'month'" [class.btn-primary]="range === 'month'">
                Monat
              </button>
              <button (click)="GetAggregatedData('year')" class="btn mr-4"
                      [class.btn-outline-primary]="range !== 'year'" [class.btn-primary]="range === 'year'">
                Jahr
              </button>
            </div>-->
          </div>
        </div>
        <!--<div class="card-header">
          <div class="row align-items-center">
            <div class="col-auto">
              <button (click)="decrement(range)" class="btn mr-2 btn-outline-primary">
                <i class="fe fe-chevron-left"></i>
              </button>
              <label *ngIf="range =='hour'" class=" mr-2 btn-outline-primary">
                {{currentDay}}
              </label>
              <label *ngIf="range =='month'" class=" mr-2 btn-outline-primary">
                {{currentMonth | humanizedMonth}}
              </label>
              <label *ngIf="range =='year'" class=" mr-2 btn-outline-primary">
                {{currentYear}}
              </label>
              <button (click)="increment(range)" class="btn mr-4 btn-outline-primary">
                <i class="fe fe-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>-->
        <div class="card-body">
          <div class="row">
            <!--<div class=" col-1 ">
              <div style="margin-top: 150px;  min-width: 30px;">
                <p class="rotate" style="text-align:right; align-self: auto;">Liter</p>
              </div>
            </div>
            <div class=" col-10 col-sm-11">
              <div style="height: 300px">
                <ed-bar-chart [data]="waterConsuptionAggregation"></ed-bar-chart>
                <p style="text-align: center">{{labelX}}</p>
              </div>
            </div>-->
            <div class="col-12 col-xl-12">
              <div style="height: 350px">
                <ed-bar-chart [data]="waterConsuptionAggregation"></ed-bar-chart>
                <p style="text-align: center">{{labelX}}</p>
              </div>
            </div>
            <!--New Chart-->
            <!-- <div class="col-12 col-xl-6">
              <div style="height: 350px">
                <ed-line-chart [data]="waterPressureAggregation"
                               labelY="bar"></ed-line-chart>
                <p style="text-align: center">{{labelX}}</p>
              </div>
            </div> -->
          </div>
        </div>
        <div class="card-footer bg-footer">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <span>∑ {{totalEuroAmount | decimalDigits}} €</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
